import Popup from './popup-window';

class PopupHandler {
    constructor(popupSelector) {
        this.popupSelector = popupSelector;
        this.popupBanner = document.querySelector(popupSelector);
        this.now = new Date();
    }

    bannerClickListener() {
        const bannerLinks = document.querySelectorAll('.js-banner-link');

        bannerLinks &&
            bannerLinks.forEach((bannerLink) => {
                bannerLink &&
                    bannerLink.addEventListener('click', async (event) => {
                        event.preventDefault();
                        const link = event.target;

                        const res = await this.fetchIncreaseNumberCount(
                            link,
                            'click_counter'
                        );

                        if (res.success) {
                            const target = link.target || '_self';

                            if (target === '_blank') {
                                window.open(link.href, '_blank');
                            } else {
                                window.location.href = link.href;
                            }
                        }
                    });
            });
    }

    async fetchIncreaseNumberCount(linkTarget, fieldName = '') {
        const formData = new FormData();

        const bannerId = linkTarget?.dataset.banner_id ?? 0;

        formData.append('action', 'increase_number_count');
        formData.append('banner_id', bannerId);
        formData.append('field_name', fieldName);

        // eslint-disable-next-line no-undef
        const resJSON = await fetch(var_from_php.ajax_url, {
            method: 'POST',
            body: formData,
        });

        const res = await resJSON.json();

        return res;
    }

    getCookie(name) {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? match[2] : undefined;
    }

    setCookie(name, value, hours) {
        const date = new Date();
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        const expires = `expires=${date.toUTCString()}`;

        document.cookie = `${name}=${value};${expires};path=/`;
    }

    async increasePopupShowCounter(popupClass) {
        const popupLink = document.querySelector(
            `${popupClass} .js-banner-link`
        );

        if (!popupLink) return false;

        const res = await this.fetchIncreaseNumberCount(
            popupLink,
            'show_counter'
        );
        // console.log('res', res);

        return res.success;
    }

    openPopup(popupClass, delay) {
        const popupInstance = new Popup();
        popupInstance.openOnePopup(popupClass, delay);
        this.increasePopupShowCounter(popupClass);
        const popupCookieData = document.querySelector(
            '#banner-popup .banner-swiper'
        );
        const popupCookiePeriod = popupCookieData.dataset.cookie_period ?? 0;
        this.setCookie('banner-popup-showed', 'true', popupCookiePeriod);
    }

    handleTimeDelay() {
        if (this.getCookie('banner-popup-showed')) return;

        if (this.popupBanner?.dataset?.enter_page_timer) {
            const cleanedDataAttr =
                this.popupBanner?.dataset?.enter_page_timer.replace(
                    /"/g,
                    '"'
                ) ?? '';
            const delay = parseInt(cleanedDataAttr, 10);

            this.openPopup(this.popupSelector, delay);
        }
    }

    handleScrollTrigger() {
        if (this.getCookie('banner-popup-showed')) return;

        if (this.popupBanner?.dataset?.scroll_page) {
            const percentTrigger = parseInt(
                this.popupBanner?.dataset?.scroll_page ?? '1',
                10
            );

            const onScroll = () => {
                const documentHeight =
                    document.documentElement.scrollHeight - window.innerHeight;
                const scrollPosition = window.scrollY;
                const scrollPercentage =
                    (scrollPosition / documentHeight) * 100;

                if (scrollPercentage >= percentTrigger) {
                    this.openPopup(this.popupSelector);
                    window.removeEventListener('scroll', onScroll);
                }
            };

            window.addEventListener('scroll', onScroll);
        }
    }

    handleMouseLeave() {
        if (this.getCookie('banner-popup-showed')) return;

        if (
            this.popupBanner?.dataset?.exit_page &&
            this.popupBanner?.dataset?.exit_page === 'true'
        ) {
            const action = (event) => {
                if (event.clientY <= 0) {
                    this.openPopup(this.popupSelector);
                    document.removeEventListener('mouseleave', action);
                }
            };
            document.addEventListener('mouseleave', action);
        }
    }

    initializePopup() {
        if (!this.popupBanner) return;

        this.bannerClickListener();

        this.handleTimeDelay();
        this.handleScrollTrigger();
        this.handleMouseLeave();
    }
}

export default PopupHandler;
